import { useMemo } from "react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import PropTypes from "prop-types";

import { useNotification } from "@hmn/coolinarika-web-core/hooks";

import { withErrorBoundary } from "../../../ErrorBoundary";
import { Notice, noticeSeverity } from "../../../Notice";
import styles from "./Notification.style";

const UploaderNotificationStyled = styled.div((props) => ({ ...styles(props) }));

const UploaderNotification = ({ uid }) => {
    const { notification, _hideNotification, _isShown } = useNotification({
        id: uid,
    });
    const { id, message, options } = notification;

    const severity = useMemo(() => {
        if (!options?.type) {
            return noticeSeverity.SUCCESS;
        }

        const severityKey = Object.keys(noticeSeverity).find(
            (key) => noticeSeverity[key] === options?.type,
        );

        return noticeSeverity[severityKey] || noticeSeverity.SUCCESS;
    }, [options?.type]);

    if (!id) {
        return null;
    }

    return (
        <UploaderNotificationStyled>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0, transition: { duration: 0.2 } }}
            >
                <Notice severity={severity} message={message} />
            </motion.div>
        </UploaderNotificationStyled>
    );
};

UploaderNotification.propTypes = {
    uid: PropTypes.string.isRequired,
};

export default withErrorBoundary(UploaderNotification);
